var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AuthClient_options;
import defaultsDeep from 'lodash.defaultsdeep';
const silentCheckSsoRedirectUri = `${window.location.origin}/.well-known/openid-silent-check-sso.html`;
export const defaultOptions = {
    config: {
        realm: '',
        clientId: '',
        url: '',
    },
    init: {
        onFailureRedirectURL: 'https://www.storebrand.no/infosider/driftsmelding-kc',
        silentCheckSsoRedirectUri,
        checkLoginIframe: true,
        messageReceiveTimeout: 3000,
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        scope: '',
    },
    login: {
        scope: '',
        allowedACR: [],
        allowedAMR: [],
        timeout: 5000,
    },
    logout: {
        redirectUri: `${window.location.origin}/logg-ut/`,
    },
    windowProp: 'stbauth',
    autoRefresh: false,
};
class AuthClient {
    constructor(options) {
        _AuthClient_options.set(this, void 0);
        __classPrivateFieldSet(this, _AuthClient_options, defaultsDeep(options, defaultOptions), "f");
        const { windowProp } = this.options;
        if (windowProp) {
            window[windowProp] = this;
        }
    }
    /**
     * If no allowedACR or allowedAMR is set, return false
     * If acr is present in allowedACR or amr is present in allowedAMR, return false
     * otherwise return true
    */
    get needStepUp() {
        var _a, _b;
        const { acr, amr } = this.idTokenParsed;
        const { allowedACR, allowedAMR } = this.options.login;
        /** if both allowedACR and allowedAMR are empty */
        if ((!allowedACR || allowedACR.length === 0)
            && (!allowedAMR || allowedAMR.length === 0)) {
            return false;
        }
        const hasTokenAllowedACR = (_a = allowedACR === null || allowedACR === void 0 ? void 0 : allowedACR.includes(acr)) !== null && _a !== void 0 ? _a : false;
        const hasTokenAllowedAMR = (_b = allowedAMR === null || allowedAMR === void 0 ? void 0 : allowedAMR.includes(amr)) !== null && _b !== void 0 ? _b : false;
        /** if token contains either allowed ACR or allowed AMR */
        if (hasTokenAllowedACR || hasTokenAllowedAMR) {
            return false;
        }
        /** already as secure as possible */
        if (!this.canStepUp) {
            return false;
        }
        return true;
    }
    get options() {
        return __classPrivateFieldGet(this, _AuthClient_options, "f");
    }
    get sub() {
        return this.idTokenParsed.sub;
    }
    get nin() {
        return this.idTokenParsed.no_nin;
    }
    get canStepUp() {
        var _a;
        return !((_a = this.idTokenParsed.acr) === null || _a === void 0 ? void 0 : _a.includes('al4'));
    }
}
_AuthClient_options = new WeakMap();
export default AuthClient;
